"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMockContext = createMockContext;
exports._attach = _attach;
Object.defineProperty(exports, "ContextRegistry", {
  enumerable: true,
  get: function get() {
    return _context2["default"];
  }
});
exports.attach = exports.createContextRegistry = exports.registerHelper = exports.registry = exports["default"] = exports.Helper = exports.ProviderError = exports.OptionsError = exports.HostError = exports.ContextError = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _lodash = _interopRequireDefault(require("lodash"));

var _properties = require("./utils/properties");

var _emitter = require("./utils/emitter");

var _string = require("./utils/string");

var _context2 = _interopRequireDefault(require("./registries/context"));

var _uuid = _interopRequireDefault(require("uuid"));
/**
 * @typedef { import("./runtime").Runtime } Runtime
 */

/**
 * @typedef { import("./utils/properties").Mixin } Mixin
 */

/**
 * @typedef { import("./utils/properties").MixinOptions } MixinOptions
 */

/**
 * @typedef {Object<string,*>} HelperAttachOptions
 * @property {String} lookupProp the property name to use for the factory function that will be attached to the Helper's host.
 * @property {String} registryProp the property name to use for the registry that will know about each of the Helpers available.
 * @property {ContextRegistry} registry an instance of a registry that will contain references to each of the Helper modules.
 * @property {Boolean} cacheHelper whether to cache the helper instance.
 * @property {Boolean} isCacheable whether to cache the helper instance.
 */


var flatten = _lodash["default"].flatten,
    castArray = _lodash["default"].castArray,
    isUndefined = _lodash["default"].isUndefined,
    partialRight = _lodash["default"].partialRight,
    mapValues = _lodash["default"].mapValues,
    pickBy = _lodash["default"].pickBy,
    isFunction = _lodash["default"].isFunction,
    omitBy = _lodash["default"].omitBy,
    defaults = _lodash["default"].defaults,
    defaultsDeep = _lodash["default"].defaultsDeep,
    omit = _lodash["default"].omit,
    result = _lodash["default"].result,
    _keys = _lodash["default"].keys,
    has = _lodash["default"].has;
var req = createMockContext({});
var REGISTRY;
REGISTRY = REGISTRY || new _context2["default"]('helpers', {
  context: req,
  componentWillRegister: function componentWillRegister() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args;
  }
});

var ContextError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2["default"])(ContextError, _Error);

  function ContextError() {
    (0, _classCallCheck2["default"])(this, ContextError);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ContextError).apply(this, arguments));
  }

  return ContextError;
}((0, _wrapNativeSuper2["default"])(Error));

exports.ContextError = ContextError;

var HostError =
/*#__PURE__*/
function (_Error2) {
  (0, _inherits2["default"])(HostError, _Error2);

  function HostError() {
    (0, _classCallCheck2["default"])(this, HostError);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(HostError).apply(this, arguments));
  }

  return HostError;
}((0, _wrapNativeSuper2["default"])(Error));

exports.HostError = HostError;

var OptionsError =
/*#__PURE__*/
function (_Error3) {
  (0, _inherits2["default"])(OptionsError, _Error3);

  function OptionsError() {
    (0, _classCallCheck2["default"])(this, OptionsError);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(OptionsError).apply(this, arguments));
  }

  return OptionsError;
}((0, _wrapNativeSuper2["default"])(Error));

exports.OptionsError = OptionsError;

var ProviderError =
/*#__PURE__*/
function (_Error4) {
  (0, _inherits2["default"])(ProviderError, _Error4);

  function ProviderError() {
    (0, _classCallCheck2["default"])(this, ProviderError);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProviderError).apply(this, arguments));
  }

  return ProviderError;
}((0, _wrapNativeSuper2["default"])(Error));
/**
 * @class       Helper
 * @classdesc   Helpers act as a registry for specific types of Javascript modules
 *              that are to be made available to a project runtime.  Helpers exist to provide
 *              common behavior, interfaces, and life cycle events and hooks for all types of things
 *              such as servers, compilers, commands, or anything else that can be categorized and grouped.
 *              Helpers are designed to be shared across multiple projects, and there are event Project Type helpers
 *              which exist to make specific types of helpers available to specific types of projects.
 */


exports.ProviderError = ProviderError;

var Helper =
/*#__PURE__*/
function () {
  /**
   * @param {Object} options
   * @param {Object} [options.provider={}] the exports of module which is being wrapped
   * @param {String} [options.name] the name of the helper
   * @param {Boolean} [options.initialize] whether or not to run the initialize function, useful for testing
   */
  function Helper() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, Helper);
    (0, _defineProperty2["default"])(this, "isInitialized", false);
    (0, _properties.enhanceObject)(this, {
      propUtils: false,
      includeLodashMethods: false,
      includeChain: false
    }, _lodash["default"]);
    (0, _emitter.attach)(this);
    var runtime = context.runtime || context.host || context.project;
    var id = [runtime.id || this.registryName, this.name, Math.floor(new Date() / 100)].join(':');
    var _options$provider = options.provider,
        provider = _options$provider === void 0 ? {} : _options$provider,
        restOfOptions = (0, _objectWithoutProperties2["default"])(options, ["provider"]);
    this.hideProperties({
      _id: id,
      _runtime: runtime,
      _provider: provider,
      _context: context,
      _options: restOfOptions,
      _name: options.name,
      uuid: (0, _uuid["default"])()
    });

    try {
      this.hideGetter("is".concat(this.constructor.helperName || this.constructor.name), function () {
        return true;
      });
    } catch (error) {}

    if (runtime.beforeHelperCreate) {
      runtime.beforeHelperCreate(this, options, context, this.constructor);
    }

    if (options.initialize !== false) {
      this.doInitialize();
    }
  }
  /**
   * This is a special property that provides a safe way of detecting if something is a class and subclasses Helper
   * @static
   * @readonly
   * @memberof Helper
   */


  (0, _createClass2["default"])(Helper, [{
    key: "lazy",

    /**
     * Creates a lazy loading property on an object.
     *
     * @param {String} attribute The property name
     * @param {Function} fn The function that will be memoized
     * @param {Boolean} enumerable Whether to make the property enumerable when it is loaded
     * @return {Helper#}
     */
    value: function lazy(attribute, fn) {
      var enumerable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return (0, _properties.propertyUtils)(this).lazy(attribute, fn, enumerable);
    }
    /**
     * creates a non enumerable property on the target object
     *
     * @param {String} attribute
     * @param {*} value
     * @param {Object} options
     * @memberof Helper#
     *
     */

  }, {
    key: "hide",
    value: function hide(attribute, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return (0, _properties.propertyUtils)(this).hide(attribute, value, options);
    }
    /**
     * creates a non enumerable property on the helper
     *
     * @param {String} attribute
     * @param {*} value
     * @param {Object} options
     * @memberof Helper#
     *
     */

  }, {
    key: "hideProperty",
    value: function hideProperty(attribute, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return (0, _properties.propertyUtils)(this).hide(attribute, value, options);
    }
    /**
     * creates multiple non-enumerable properties on the helper
     *
     * @param {Object<string,object>} properties
     * @memberof Helper#
     *
     */

  }, {
    key: "hideProperties",
    value: function hideProperties() {
      var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _properties.propertyUtils)(this).hideProperties(properties);
    }
    /**
     * Create a hidden getter property on the object.
     *
     * @param {String} attribute    The name of the property
     * @param {Function} fn      A function to call to return the desired value
     * @param {Object} [options={}]
     * @param {Object} [options.scope=this]
     * @param {Array} [options.args=[]] arguments that will be passed to the function
     * @memberof Helper#
     * @return {Helper#}
     */

  }, {
    key: "hideGetter",
    value: function hideGetter(attribute, fn) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return (0, _properties.propertyUtils)(this).hideGetter(attribute, fn, options);
    }
    /**
     * Create a hidden getter property on the object.
     *
     * @param {String} attribute    The name of the property
     * @param {Function} fn      A function to call to return the desired value
     * @param {Object} [options={}]
     * @param {Object} [options.scope=this]
     * @param {Array} [options.args=[]] arguments that will be passed to the function
     * @memberof Helper#
     * @return {Helper}
     */

  }, {
    key: "getter",
    value: function getter(attribute, fn) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return (0, _properties.propertyUtils)(this).getter(attribute, fn, options);
    }
    /**
     * @param {Mixin} methods - an object of functions that will be applied to the target
     * @param {MixinOptions} options - options for the mixin attributes
     */

  }, {
    key: "applyInterface",
    value: function applyInterface() {
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _properties.propertyUtils)(this).applyInterface(methods, options);
    }
  }, {
    key: "at",
    value: function at() {
      for (var _len2 = arguments.length, paths = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        paths[_key2] = arguments[_key2];
      }

      return _lodash["default"].at.apply(_lodash["default"], [this].concat(paths));
    }
  }, {
    key: "set",
    value: function set(path, value) {
      return _lodash["default"].set(this, path, value);
    }
  }, {
    key: "get",
    value: function get(path, defaultValue) {
      return _lodash["default"].get(this, path, defaultValue);
    }
  }, {
    key: "result",
    value: function result(path, defaultValue) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return _lodash["default"].result.apply(_lodash["default"], [this, path, defaultValue].concat(args));
    }
  }, {
    key: "has",
    value: function has(path) {
      return _lodash["default"].has(this, path);
    }
  }, {
    key: "invoke",
    value: function invoke() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _lodash["default"].invoke.apply(_lodash["default"], [this].concat(args));
    }
  }, {
    key: "pick",
    value: function pick() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _lodash["default"].pick.apply(_lodash["default"], [this].concat(args));
    }
  }, {
    key: "doInitialize",

    /** */
    value: function () {
      var _doInitialize = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var initializer;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                initializer = this.tryGet('initialize', this.initialize);
                this.fireHook('beforeInitialize');

                if (!initializer) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return Promise.resolve(initializer.call(this, this.options, this.context));

              case 5:
                this.hide('isInitialized', true);

              case 6:
                this.fireHook('afterInitialize');
                return _context.abrupt("return", this);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function doInitialize() {
        return _doInitialize.apply(this, arguments);
      }

      return doInitialize;
    }()
    /**
     * Sets the initial state of the object.  This is called in the Helper constructor
     *
     * @private
     */

  }, {
    key: "setInitialState",
    value: function setInitialState() {
      var _this = this;

      var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.initialState || {};
      var defaultsDeep = this.lodash.defaultsDeep;

      if (this.state && this.tryGet('initialState')) {
        return Promise.resolve(this.attemptMethodAsync('initialState')).then(function (i) {
          if ((0, _typeof2["default"])(i) === 'object') {
            _this.state.merge(defaultsDeep({}, i, initialState));
          }
        })["catch"](function (error) {
          console.error('Error setting initial state', _this, error);
          _this.initialStateError = error;
        });
      }
    }
  }, {
    key: "fireHook",
    value: function fireHook(hookName) {
      var _this$helperEvents;

      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      (_this$helperEvents = this.helperEvents).emit.apply(_this$helperEvents, ["".concat(this.registryName, ":").concat(hookName), this].concat(args));

      this.emit.apply(this, [hookName].concat(args));
      this.emit.apply(this, ['firingHook', hookName].concat(args));
      this.attemptMethod(hookName, {
        args: args
      });
    }
    /**
     * Access the first value we find in our options hash in our provider hash
     *
     * @param {String} objectPath the dot.path to the property
     * @param {*} [defaultValue] the default value
     * @param {Array<String>} sources property paths to search
     * @returns {*}
     * @memberof Helper
     */

  }, {
    key: "tryGet",
    value: function tryGet(objectPath, defaultValue) {
      var sources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['options', 'provider', 'provider.default.prototype', 'provider.default', 'provider.prototype'];
      var values = this.at.apply(this, (0, _toConsumableArray2["default"])(sources.map(function (s) {
        return "".concat(s, ".").concat(objectPath);
      }))).filter(function (v) {
        return !isUndefined(v);
      });
      return values.length ? values[0] : defaultValue;
    }
    /**
     * Access the first value we find in our options hash in our provider hash
     *
     * If the method is a function, it will be called in the scope of the helper,
     * with the helpers options and context
     *
     * @param {String} objectPath the dot.path to the property
     * @param {*} defaultValue the default value
     * @param {Object} options options object which will be passed to the property if it is a function
     * @param {Object} context context object which will be passed to the property if it is a function
     * @returns {*}
     * @memberof Helper
     */

  }, {
    key: "tryResult",
    value: function tryResult(property, defaultValue) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var val = this.tryGet(property);

      if (!val) {
        return typeof defaultValue === 'function' ? defaultValue.call(this, (0, _objectSpread3["default"])({}, this.options, options), (0, _objectSpread3["default"])({}, this.context, context)) : defaultValue;
      } else if (typeof val === 'function') {
        return val.call(this, (0, _objectSpread3["default"])({}, this.options, options), (0, _objectSpread3["default"])({}, this.context, context));
      } else {
        return val;
      }
    } // Merge the objects found at k starting with at options, provider, runtimeSettings

  }, {
    key: "mergeGet",
    value: function mergeGet(key) {
      var _this2 = this;

      var namespaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['options', 'provider', 'runtimeSettings'];
      key = typeof key === 'string' ? key.split('.') : key;
      key = flatten(castArray(key));
      return defaults.apply(void 0, [{}].concat((0, _toConsumableArray2["default"])(namespaces.map(function (n) {
        return _this2.get([n].concat((0, _toConsumableArray2["default"])(key)));
      }))));
    } // Merge the objects found at k starting with at options, provider, runtimeSettings
    // If the property is a function, it will be called in the scope of the helper, with the helpers options and context

  }, {
    key: "mergeResult",
    value: function mergeResult(key) {
      var _this3 = this;

      var namespaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['options', 'provider', 'runtimeSettings'];
      key = typeof key === 'string' ? key.split('.') : key;
      key = flatten(castArray(key));

      var ifFunc = function ifFunc(v) {
        return typeof v === 'function' ? v.call(_this3, _this3.options, _this3.context) : v;
      };

      return defaults.apply(void 0, [{}].concat((0, _toConsumableArray2["default"])(namespaces.map(function (n) {
        return _this3.get([n].concat((0, _toConsumableArray2["default"])(key)));
      }).map(ifFunc))));
    }
  }, {
    key: "slice",
    value: function slice() {
      for (var _len7 = arguments.length, properties = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        properties[_key7] = arguments[_key7];
      }

      return _lodash["default"].zipObjectDeep(properties, this.at(properties));
    }
  }, {
    key: "createMixin",
    value: function createMixin() {
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
      console.warn('createMixin is deprecated');
      var functions = pickBy(methods, isFunction);
      var partialed = mapValues(functions, function (fn) {
        return partialRight(fn.bind(target), context);
      });
      return mapValues(partialed, function (boundFn) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
            args[_key8 - 1] = arguments[_key8];
          }

          return boundFn.apply(void 0, [options].concat(args));
        };
      });
    }
  }, {
    key: "applyMixin",
    value: function applyMixin() {
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.provider;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
      var target = arguments.length > 2 ? arguments[2] : undefined;
      console.warn('applyMixin is deprecated');
      return Object.assign(this, this.createMixin(methods, context, target));
    }
  }, {
    key: "mixin",
    value: function mixin() {
      var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.applyInterface(object, (0, _objectSpread3["default"])({
        transformKeys: true,
        scope: this,
        partial: [this.context],
        right: true,
        insertOptions: false,
        hidden: false
      }, options));
      return this;
    }
  }, {
    key: "attemptMethod",
    value: function attemptMethod(methodName) {
      var handler = this.tryGet(methodName, this[methodName]);

      if (typeof handler === 'undefined') {
        if (this.runtime.isDevelopment && this.runtime.get('environment.DEBUG_HELPERS')) {
          this.runtime.debug("attemptMethod called on non-existent method: ".concat(methodName, " "), {
            name: this.name,
            id: this.id
          });
        }

        return false;
      }

      if (typeof handler === 'function') {
        for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
          args[_key9 - 1] = arguments[_key9];
        }

        if (args.length === 0) {
          args.unshift({});
        }

        args.push(this.context);

        try {
          return handler.call.apply(handler, [this].concat(args));
        } catch (error) {
          return false;
        }
      }

      return handler;
    }
  }, {
    key: "attemptMethodAsync",
    value: function attemptMethodAsync(name) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      var result = this.attemptMethod.apply(this, [name].concat(args));
      return Promise.resolve(result || null);
    }
  }, {
    key: "callMethod",
    value: function callMethod(methodName) {
      var handler = this.tryGet(methodName, this[methodName]);

      if (typeof handler !== 'function') {
        throw new Error("Could not find a property at ".concat(methodName));
      }

      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      if (args.length === 0) {
        args.unshift({});
      }

      return handler.call.apply(handler, [this].concat([].concat(args, [this.context])));
    }
  }, {
    key: "providerTypes",
    get: function get() {
      return defaults({}, this.tryResult('providerTypes', {}), this.constructor.providerTypes, Helper.providerTypes);
    }
    /**
     * Individual helper modules can reference the options type configuration from their constructor, and can override
     * them by passing in optionTypes object in their options, by exporting a optionTypes object themselves.
     * @memberof Helper#
     */

  }, {
    key: "optionTypes",
    get: function get() {
      return defaults({}, this.tryResult('optionTypes', {}), this.constructor.optionTypes, Helper.optionTypes);
    }
    /**
     * Individual helper modules can reference the context type configuration from their constructor, and can override
     * them by passing in a contextTypes object in their options, by exporting a contextTypes object themselves.
     * @memberof Helper#
     */

  }, {
    key: "contextTypes",
    get: function get() {
      return defaults({}, (0, _defineProperty2["default"])({}, this.registryName, this.constructor.registry), this.tryResult('contextTypes', {}), this.constructor.contextTypes, Helper.contextTypes);
    }
    /**
     * Attaching a Helper class to a host, usually an instance of Runtime,
     * will create a factory function that can be used to create Helper instances,
     * as well as a Registry that contains all known providers of the specific Helper class
     * we are attaching.
     *
     * @static
     * @param {Runtime} host
     * @param {Class} helperClass
     * @param {HelperAttachOptions} options
     * @returns {Runtime}
     * @memberof Helper
     */

  }, {
    key: "name",

    /**
     * Returns the name of this helper
     *
     * @readonly
     * @memberof Helper
     */
    get: function get() {
      return this._name;
    }
    /**
     * A Unique ID for this helper instance
     *
     * @readonly
     * @memberof Helper
     */

  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
    /**
     * @readonly
     * @memberof Helper#
     * @type {Runtime}
     */

  }, {
    key: "runtime",
    get: function get() {
      return this._runtime;
    }
    /**
     * @alias Helper#runtime
     * @deprecated
     */

  }, {
    key: "host",
    get: function get() {
      return this.runtime;
    }
    /**
     * @alias Helper#runtime
     * @deprecated
     */

  }, {
    key: "project",
    get: function get() {
      return this.runtime;
    }
    /**
     * Gets the options this helper was created with
     *
     * @readonly
     * @memberof Helper#
     */

  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
    /**
     * Gets the context this helper was created with
     *
     * @readonly
     * @memberof Helper#
     */

  }, {
    key: "context",
    get: function get() {
      return this._context;
    }
  }, {
    key: "provider",
    get: function get() {
      return this._provider;
    }
    /**
     * Returns the name of the registry this helper will belong to,
     * which can be used to emit global events to helper specific channels
     *
     * @readonly
     * @memberof Helper
     */

  }, {
    key: "registryName",
    get: function get() {
      return this.constructor.registryName || Helper.propNames(this.constructor.helperName || this.constructor.name).registryProp;
    }
    /**
     * Returns a lodash chain object, using this helper instance as the source value
     *
     * @readonly
     * @memberof Helper
     */

  }, {
    key: "chain",
    get: function get() {
      return _lodash["default"].chain(this);
    }
  }, {
    key: "lodash",
    get: function get() {
      return _lodash["default"];
    }
  }, {
    key: "helperEvents",
    get: function get() {
      return Helper.events;
    }
  }, {
    key: "isCached",
    get: function get() {
      return !!this.get('options.cacheable') && this.cacheKey && this.cacheKey.length > 0;
    }
  }, {
    key: "cacheKey",
    get: function get() {
      return this.get('options.cacheKey');
    }
  }, {
    key: "invalidOptionKeys",
    get: function get() {
      return this.chain.get('options').omit(Object.keys(this.optionTypes)).keys().value();
    }
  }, {
    key: "invalidContextKeys",
    get: function get() {
      return this.chain.get('context').omit(Object.keys(this.contextTypes)).keys().value();
    }
  }, {
    key: "argv",
    get: function get() {
      return omit(this.get('runtime.argv', this.get('host.argv', {})), '_', '');
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return defaultsDeep({}, this.argv, this.runtimeSettings);
    }
  }, {
    key: "runtimeSettings",
    get: function get() {
      var name = this.name || this.id;
      var cased = (0, _string.camelCase)((0, _string.snakeCase)(name));
      var omit = this.lodash.omit;
      var _this$projectSettings = this.projectSettingsPaths,
          projectSettingsPaths = _this$projectSettings === void 0 ? [] : _this$projectSettings;
      return omit(defaultsDeep.apply(void 0, [{}].concat((0, _toConsumableArray2["default"])(this.at(projectSettingsPaths)))), name, cased);
    }
    /**
     * The object search paths where we look for settings and configuration
     *
     * @readonly
     * @memberof Helper
     */

  }, {
    key: "projectSettingsPaths",
    get: function get() {
      var groupName = this.constructor.registryName();
      var name = this.name || this.id;
      return ["runtime.argv.".concat(groupName, ".").concat(name), "runtime.options.".concat(groupName, ".").concat(name), "runtime.settings.".concat(groupName, ".").concat(name), "runtime.argv.".concat(groupName, ".").concat((0, _string.camelCase)((0, _string.snakeCase)(name))), "runtime.options.".concat(groupName, ".").concat((0, _string.camelCase)((0, _string.snakeCase)(name))), "runtime.settings.".concat(groupName, ".").concat((0, _string.camelCase)((0, _string.snakeCase)(name)))].map(function (str) {
        return str.replace(/(\\|\/)/g, '.');
      });
    }
  }], [{
    key: "registerHelper",
    value: function registerHelper(name, fn) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var reg = fn && fn.prototype instanceof Helper ? function () {
        return fn;
      } : fn;

      try {
        var _result = REGISTRY.registry.register(name, reg);

        var host = options.host || options.runtime || options.project;

        if (host && options.attach !== false) {
          var helper = REGISTRY.registry.lookup(name);
          helper.attach(host, options);
        }

        Helper.events.emit('registered', {
          name: name,
          options: options
        });
        return _result;
      } catch (error) {
        Helper.events.emit('register:error', {
          name: name,
          error: error,
          options: options
        });
      }
    }
    /**
     * Creates an instance of the Helper class.  This is usually called via the factory function
     * that gets attached to the runtime when you say Helper.attach, which makes it possible to only
     * specify options but still get context, runtime, and helper class passed automatically.
     *
     * @param {Object} options properties that get attached to the helper instance
     * @param {Object} context context to be passed down from the parent
     * @param {Runtime} runtime the parent runtime that is creating this helper
     * @param {Class} helperClass any subclass of Helper
     */

  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var runtime = arguments.length > 2 ? arguments[2] : undefined;
      var helperClass = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this;
      helperClass = helperClass || this;
      var shortcut = helperClass.shortcut || helperClass.prototype.shortcut;
      var helperInstance = new helperClass((0, _objectSpread3["default"])({}, options, shortcut ? {
        shortcut: shortcut
      } : {}), (0, _objectSpread3["default"])({}, context, {
        runtime: runtime
      }));
      return helperInstance;
    }
    /**
     * Helper classes can specify attributes that individual helper modules are
     * expected to provide or export.
     */

  }, {
    key: "attach",
    value: function attach(host, helperClass, options) {
      var isPlainObject = _lodash["default"].isPlainObject;

      if (isPlainObject(helperClass)) {
        options = helperClass;
        helperClass = this;
      }

      Helper.events.emit('attach', host, helperClass, options);

      var result = _attach(host, helperClass, options);

      Helper.events.emit('attached', host, helperClass, options);
      return result;
    }
  }, {
    key: "attachAll",
    value: function attachAll(host) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Helper.events.emit('attachAll', host, options);

      if (!this.isHostValid(host)) {
        throw new Error('Invalid host for the helper registry. pass a project or a portfolio');
      }

      Helper.allHelperTypes.forEach(function (helperType) {
        if (helperType.isHostSupported && helperType.isHostSupported(host)) {
          helperType.attach(host, options);
        }
      });
      return host;
    }
  }, {
    key: "isHostSupported",
    value: function isHostSupported(host) {
      return this.isHostValid(host);
    }
  }, {
    key: "isHostValid",
    value: function isHostValid(host) {
      return typeof host.hide === 'function' && typeof host.lazy === 'function';
    }
  }, {
    key: "cacheable",
    value: function cacheable() {
      var setting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this.isCacheable = !!setting;
    }
  }, {
    key: "createContextRegistry",
    value: function createContextRegistry() {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }

      return (0, _construct2["default"])(_context2["default"], args);
    }
  }, {
    key: "createRegistry",
    value: function createRegistry() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }

      return (0, _construct2["default"])(_context2["default"], args);
    }
    /**
     * @abstract
     */

  }, {
    key: "willCreateHelper",
    value: function willCreateHelper(host, opts) {}
    /**
     * @abstract
     */

  }, {
    key: "didCreateHelper",
    value: function didCreateHelper(host, helperInstance, opts) {}
    /**
     * @private
     */

  }, {
    key: "registryName",
    value: function registryName() {
      return Helper.propNames(this.name).registryProp;
    }
  }, {
    key: "createMixin",
    value: function createMixin() {
      var methods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var target = arguments.length > 1 ? arguments[1] : undefined;

      for (var _len14 = arguments.length, partialArgs = new Array(_len14 > 2 ? _len14 - 2 : 0), _key14 = 2; _key14 < _len14; _key14++) {
        partialArgs[_key14 - 2] = arguments[_key14];
      }

      var functions = pickBy(methods, isFunction);
      var partialed = mapValues(functions, function (fn) {
        return partialRight.apply(void 0, [fn.bind(target)].concat(partialArgs));
      });
      return mapValues(partialed, function (boundFn) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          for (var _len15 = arguments.length, args = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
            args[_key15 - 1] = arguments[_key15];
          }

          return boundFn.apply(void 0, [options].concat(args));
        };
      });
    }
  }, {
    key: "propNames",
    value: function propNames() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return {
        registryProp: (0, _string.camelCase)((0, _string.pluralize)((0, _string.snakeCase)(name))),
        lookupProp: (0, _string.singularize)((0, _string.camelCase)((0, _string.snakeCase)(name)))
      };
    }
  }, {
    key: "isSkypagerHelper",
    get: function get() {
      return true;
    }
  }, {
    key: "features",
    get: function get() {
      return Helper.registry.lookup('feature').Feature.registry;
    }
  }, {
    key: "allHelpers",
    get: function get() {
      return Helper.allHelperTypes;
    }
  }, {
    key: "allHelperTypes",
    get: function get() {
      return Helper.registry.available.map(function (id) {
        return Helper.registry.lookup(id);
      }).map(function (mod) {
        return mod["default"] ? mod["default"] : mod;
      });
    }
  }, {
    key: "modules",
    get: function get() {
      return Helper;
    }
  }]);
  return Helper;
}();

exports.Helper = Helper;
(0, _defineProperty2["default"])(Helper, "helperName", 'Helper');
(0, _defineProperty2["default"])(Helper, "registry", REGISTRY);
(0, _defineProperty2["default"])(Helper, "ContextRegistry", _context2["default"]);
(0, _defineProperty2["default"])(Helper, "ContextError", ContextError);
(0, _defineProperty2["default"])(Helper, "OptionsError", OptionsError);
(0, _defineProperty2["default"])(Helper, "ProviderError", ProviderError);
(0, _defineProperty2["default"])(Helper, "events", (0, _emitter.attach)({}));
(0, _defineProperty2["default"])(Helper, "providerTypes", {});
(0, _defineProperty2["default"])(Helper, "optionTypes", {
  id: 'string',
  provider: 'object'
  /**
   * Helpers are always passed a context property from the host project or runtime's sandbox,
   * this will include a reference to the host project, as well as the registry the helper belongs to
   * and things such as the environment or process argv.
   */

});
(0, _defineProperty2["default"])(Helper, "contextTypes", {
  project: 'object',
  reg: 'object',
  host: 'object',
  runtime: 'object'
  /**
   * Individual helper modules can reference the provdier type configuration from their constructor, and can override
   * them by passing in a providerTypes object in their options, by exporting a providerTypes object themselves.
   *
   * @memberof Helper#
   */

});
(0, _defineProperty2["default"])(Helper, "createMockContext", createMockContext);
var _default = Helper;
exports["default"] = _default;

function createMockContext() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var fn = function fn(key) {
    return result(object, key, function () {
      throw new Error("Module ".concat(key, " not found in mock context"));
    });
  };

  return Object.assign(fn, {
    keys: function keys() {
      return _keys(object);
    },
    resolve: function resolve(key) {
      var resolved = has(object, key) && key;

      if (resolved) {
        return resolved;
      } else {
        throw new Error("Module ".concat(key, " not found in mock context"));
      }
    }
  });
}

var registry = Helper.registry;
exports.registry = registry;
var registerHelper = Helper.registerHelper;
exports.registerHelper = registerHelper;

var createContextRegistry = function createContextRegistry(name) {
  for (var _len16 = arguments.length, args = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
    args[_key16 - 1] = arguments[_key16];
  }

  return (0, _construct2["default"])(_context2["default"], [name].concat(args));
};

exports.createContextRegistry = createContextRegistry;
var attach = Helper.attach;
exports.attach = attach;

function _attach(host, helperClass) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _Helper$propNames$opt = (0, _objectSpread3["default"])({}, Helper.propNames(helperClass.name), options),
      registryProp = _Helper$propNames$opt.registryProp,
      lookupProp = _Helper$propNames$opt.lookupProp,
      _Helper$propNames$opt2 = _Helper$propNames$opt.configKey,
      configKey = _Helper$propNames$opt2 === void 0 ? 'options' : _Helper$propNames$opt2;

  var originalHelperClass = helperClass;

  if (host[registryProp]) {
    return host;
  }

  if (host.fireHook) {
    host.fireHook('willAttachHelpers', registryProp, helperClass, options);
  }

  (0, _properties.lazy)(host, registryProp, function () {
    return options.registry || helperClass.createRegistry();
  }); // ensures that we can always access the function

  (0, _properties.hideProperty)(host[registryProp], 'createHelperByName', function (name) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (typeof name !== 'string') {
      name = "".concat(lookupProp).concat(_lodash["default"].uniqueId());
    }

    var reg = host[registryProp];
    var _opts = opts,
        _opts$cacheHelper = _opts.cacheHelper,
        cacheHelper = _opts$cacheHelper === void 0 ? !!(helperClass.isCacheable || opts.cacheHelper) : _opts$cacheHelper;
    opts = defaults({}, opts, {
      name: name,
      id: name,
      cacheHelper: !!helperClass.isCacheable
    }, omit(host.argv, '', '_'), host.get("".concat(configKey, ".").concat(registryProp, ".").concat(name)), host.get("".concat(configKey, ".").concat(registryProp, ".").concat((0, _string.camelCase)((0, _string.snakeCase)(name)))));
    var helperContext = (0, _objectSpread3["default"])({}, host.createSandbox(ctx), (0, _defineProperty2["default"])({
      host: host,
      reg: reg
    }, registryProp, reg));
    var provider;

    try {
      provider = reg.lookup(name);
    } catch (error) {
      if (helperClass.allowAnonymousProviders || options.allowAnonymousProviders) {
        provider = opts.provider || Object.assign({}, {
          name: name
        }, opts);
      } else {
        throw error;
      }
    }

    if (provider && provider["default"] && typeof provider["default"] === 'function' && provider["default"].isSkypagerHelper) {
      helperClass = provider["default"];
      opts.shortcut = getShortcut(opts, helperClass);
    } else if (provider && typeof provider === 'function' && provider.isSkypagerHelper) {
      helperClass = provider;
      opts.shortcut = getShortcut(opts, helperClass);
    } else {
      helperClass = originalHelperClass;
    }

    var cacheable = !!(cacheHelper !== false && provider.isCacheable !== false && provider.cacheable !== false && typeof host.cache !== 'undefined');
    var cacheKey = [registryProp, (0, _properties.hashObject)(omitBy(opts, cacheableKeys)), name].join(':');
    opts.cacheKey = cacheKey;
    opts.cacheable = cacheable;
    opts.provider = provider;
    opts.shortcut = opts.shortcut || provider.shortcut || helperClass.prototype && helperClass.prototype.shortcut || helperClass.shortcut;
    opts.createGetter = opts.createGetter || provider.createGetter || opts.createGetter || opts.shortcut; // type case the values true, false, TRUE, FALSE

    _keys(opts).forEach(function (key) {
      if (typeof opts[key] === 'string' && opts[key].match(/true|false/i)) {
        opts[key] = opts[key].toLowerCase() === 'true';
      }
    });

    if (host.willCreateHelper) {
      var response = host.willCreateHelper(opts, helperClass);

      if (response === false) {
        return false;
      }
    }

    if (helperClass.willCreateHelper(host, opts) === false) {
      return false;
    }

    var helperInstance = cacheable ? host.cache.fetch(cacheKey, function () {
      return helperClass.createInstance(opts, helperContext, host, helperClass);
    }) : helperClass.createInstance(opts, helperContext, host, helperClass);

    if (opts.createGetter || opts.shortcut) {
      host.lazy(opts.createGetter || opts.shortcut, function () {
        return helperInstance;
      }, true);
    }

    helperInstance.hide('destroyHelper', function () {
      try {
        helperInstance.removeAllListeners();
        host.cache["delete"](cacheKey);
      } catch (e) {}

      helperInstance.fireHook('willBeDestroyed', helperInstance, host, opts);
      return true;
    });

    if (host.didCreateHelper) {
      host.didCreateHelper(helperInstance, opts);
    }

    helperClass.didCreateHelper(host, helperInstance, opts);

    if (helperClass.isObservable || provider.isObservable || provider.observables || opts.observables || helperClass.observables || helperClass.prototype && helperClass.prototype.observables) {
      host.fireHook('didCreateObservableHelper', helperInstance, helperClass);
    }

    return helperInstance;
  });
  (0, _properties.hideProperty)(host[registryProp], 'allInstances', function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(host[registryProp].allMembers()).map(function (id) {
      return host[lookupProp](id, options);
    });
  });
  (0, _properties.hideProperty)(host[registryProp], 'createLookup', function () {
    var defaultOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cacheHelper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : helperClass.isCacheable;
    return function (id) {
      var _host$registryProp;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      for (var _len17 = arguments.length, args = new Array(_len17 > 2 ? _len17 - 2 : 0), _key17 = 2; _key17 < _len17; _key17++) {
        args[_key17 - 2] = arguments[_key17];
      }

      return (_host$registryProp = host[registryProp]).createHelperByName.apply(_host$registryProp, [id, (0, _objectSpread3["default"])({}, defaultOptions, {
        cacheHelper: cacheHelper
      }, options)].concat(args));
    };
  });
  host.hideGetter(lookupProp, function () {
    var baseFn = function baseFn() {
      var _host$registryProp2;

      return (_host$registryProp2 = host[registryProp]).createHelperByName.apply(_host$registryProp2, arguments);
    };

    var camelCase = _lodash["default"].camelCase,
        lowerFirst = _lodash["default"].lowerFirst,
        kebabCase = _lodash["default"].kebabCase;
    host.get([registryProp, 'available']).forEach(function (helperId) {
      var parts = helperId.split('/').map(function (p) {
        return lowerFirst(camelCase(kebabCase(p)));
      });

      _lodash["default"].set(baseFn, parts, function () {
        for (var _len18 = arguments.length, rest = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
          rest[_key18] = arguments[_key18];
        }

        return baseFn.apply(void 0, [helperId].concat(rest));
      });
    });
    return baseFn;
  });

  if (host.didAttachHelpers) {
    host.didAttachHelpers.call(host, helperClass, options);
  }

  return host;
} // will not use the key if this function returns true


var cacheableKeys = function cacheableKeys() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = arguments.length > 1 ? arguments[1] : undefined;
  return isFunction(value) || value && value.then && isFunction(value.then) || key == 'provider' || key === 'compiler';
};

var getShortcut = function getShortcut() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var helperClass = arguments.length > 1 ? arguments[1] : undefined;

  var shortcut = _lodash["default"].result(opts, 'shortcut', function () {
    return _lodash["default"].result(opts, 'createGetter');
  }) || _lodash["default"].result(helperClass, 'shortcut', function () {
    return _lodash["default"].result(helperClass, 'createGetter');
  }) || _lodash["default"].result(helperClass.prototype, 'shortcut', function () {
    return _lodash["default"].result(helperClass.prototype, 'createGetter');
  });

  if (shortcut) {
    return shortcut;
  }

  var desc = Object.getOwnPropertyDescriptor(helperClass, 'shortcut') || {};
  return _lodash["default"].result(desc, 'value');
};